import { action } from '@ember/object';
import Component from '@glimmer/component';
import type DeviceModel from 'garaje/models/device';

interface GlobalDevicesIpadsIpadTileComponentSignature {
  Args: {
    ipad: DeviceModel;
    isSelected: boolean;
    unselectIPad: (ipad: DeviceModel) => void;
    selectIPad: (ipad: DeviceModel) => void;
  };
}

export default class GlobalDevicesIpadsIpadTileComponent extends Component<GlobalDevicesIpadsIpadTileComponentSignature> {
  @action
  onIPadCheckboxClick(event: MouseEvent): void {
    const ipad = this.args.ipad;

    if ((<HTMLInputElement>event.target).checked) {
      // add ipad when user select the ipad
      this.args.selectIPad(ipad);
    } else {
      // remove ipad from selected ipad
      this.args.unselectIPad(ipad);
    }
  }
}
